import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#FDFDFB]">
      <header className="border-b border-[#E2E8E4]">
        <div className="max-w-4xl mx-auto flex items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center">
            <Logo />
          </Link>
          <Link to="/" className="text-xs text-[#5C6661] inline-flex items-center gap-1 hover:text-[#121413]"><ArrowLeft className="w-3 h-3" /> Home</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-16">
        <div className="overline">Legal</div>
        <h1 className="font-display text-4xl font-extrabold tracking-tight mt-2">Privacy Policy</h1>
        <p className="text-xs text-[#5C6661] mt-2">Last updated: {new Date().toLocaleDateString()}</p>

        <div className="prose prose-sm mt-10 max-w-none text-[#121413] leading-relaxed">
          <h2 className="font-display text-xl font-bold mt-8">What we collect</h2>
          <ul className="list-disc pl-6 mt-3 space-y-1 text-[#5C6661] text-sm">
            <li>Your name and email (to run your account)</li>
            <li>Your CV file and the profile extracted from it (role, industry, skills, summary)</li>
            <li>Companies we discover for you and the applications you send</li>
            <li>Your SMTP host / port / email / app-password (encrypted at rest) — used to send emails from your own inbox</li>
            <li>An account identifier used to match your web and mobile sessions</li>
          </ul>

          <h2 className="font-display text-xl font-bold mt-8">What we don&apos;t do</h2>
          <ul className="list-disc pl-6 mt-3 space-y-1 text-[#5C6661] text-sm">
            <li>No advertising SDKs, no cross-site tracking, no data sold to third parties</li>
            <li>No email marketing beyond service messages you would expect (receipts, password resets)</li>
            <li>Your CV and SMTP password are never shared</li>
          </ul>

          <h2 className="font-display text-xl font-bold mt-8">Who processes your data</h2>
          <p className="text-sm text-[#5C6661] mt-3">
            AI parsing and cover-letter drafting are performed by Anthropic (Claude Sonnet 4.5) via the Emergent Universal Key.
            Payments are processed by Stripe. Emails are sent through the SMTP server you configure (Gmail, Outlook, etc.).
            The mobile app processes Apple in-app subscription receipts.
          </p>

          <h2 className="font-display text-xl font-bold mt-8">Your rights</h2>
          <p className="text-sm text-[#5C6661] mt-3">
            You can delete your account and all associated data at any time from <Link to="/app/settings" className="text-[#2D4A3E] underline">Settings → Delete account</Link>. That removes your account row plus your CV, discovered companies, application history, and SMTP config server-side.
          </p>

          <h2 className="font-display text-xl font-bold mt-8">Contact</h2>
          <p className="text-sm text-[#5C6661] mt-3">Questions? Reach out at <span className="font-mono">privacy@job-knocker.com</span>.</p>
        </div>
      </main>
    </div>
  );
}
